import { Box, CopyClipboard } from '@missionlabs/smartagent-app-components';
import useContact from 'hooks/redux/useContact';

import copyIcon from 'images/icon-copy-outline-white.svg';

import React from 'react';
import './customer-inputs.scss';

interface Props {}

const CustomerInputs: React.FC<Props> = () => {

    const contact = useContact();

    if (!contact?.customerInputs) return null;

    return (
        <section className="sa-customer-inputs">
            <Box
                collapse
                header={<h4>Customer Input</h4>}
            >
                <ul>
                    {contact.customerInputs.map((custInput,i) => (
                        <li className="row between middle" key={i}>
                            <p>
                                <span>{custInput.label}:&nbsp;</span>
                                <span>{custInput.value}</span>
                            </p>
                            <CopyClipboard icon={copyIcon} copyStr={custInput.value} />
                        </li>
                    ))}
                </ul>
            </Box>
        </section>
    )
}

export default CustomerInputs;